import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import theme from "./theme/theme";
import reportWebVitals from "./reportWebVitals";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider } from "@mui/material/styles";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./store";
import LoadingScreen from "./loaders/LoadingScreen";
import { BrowserRouter as Router } from "react-router-dom";
import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import ten from "./translations/en.json";
import { GoogleOAuthProvider } from "@react-oauth/google";
// import tde from "./translations/de.json"

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: ten,
    },
    // de: {
    //   translation: tde
    // }
  },
  lng: "en",
  fallbackLng: "en",
});

ReactDOM.render(
  <ThemeProvider theme={theme}>
    {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
    <CssBaseline />
    <Provider store={store}>
      <PersistGate loading={<LoadingScreen />} persistor={persistor}>
        <Router>
          <GoogleOAuthProvider clientId="717109025413-80qmpib7823lalb53gsr0qpu036gg9uj.apps.googleusercontent.com">
            <App />
          </GoogleOAuthProvider>
        </Router>
      </PersistGate>
    </Provider>
  </ThemeProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(// console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
